import React from 'react';
import MyPayslipContainer from '../../containers/MyPayslipContainer/MyPayslipContainer';

const MyPayslipPage = () => (
    <MyPayslipContainer />
);

export default MyPayslipPage;

